export default __webpack_public_path__ + "static/directdebit-fe6251864b7ad3c5890c3cf1c93b0e98.png";